export var SpacerVertical = _ref => {
  var {
    spacerColor
  } = _ref;
  return () => ({
    rootStyle: spacerColor ? {
      backgroundColor: spacerColor
    } : {}
  });
};
//# sourceMappingURL=SpacerVertical.js.map